import React from 'react'
import styles from './SlideShow.module.css'
import SlideImg from '../../Common/SlideImg/SlideImg'

export default function SlideShow() {
    const logos = [
        {
            img: '/pages/business/foodslabo/logo_1.png',
            styleClass: styles.content1,
        },
        {
            img: '/pages/business/foodslabo/logo_2.png',
            styleClass: styles.content2,
        },
        {
            img: '/pages/business/foodslabo/logo_3.png',
            styleClass: styles.content3,
        },
        {
            img: '/pages/business/foodslabo/logo_4.png',
            styleClass: styles.content4,
        },
        {
            img: '/pages/business/foodslabo/logo_5.png',
            styleClass: styles.content5,
        },
        {
            img: '/pages/business/foodslabo/logo_6.png',
            styleClass: styles.content6,
        },
        {
            img: '/pages/business/foodslabo/logo_7.png',
            styleClass: styles.content7,
        },
        {
            img: '/pages/business/foodslabo/logo_8.png',
            styleClass: styles.content8,
        },
        {
            img: '/pages/business/foodslabo/logo_9.png',
            styleClass: styles.content9,
        },
        {
            img: '/pages/business/foodslabo/logo_10.png',
            styleClass: styles.content10,
        },
        {
            img: '/pages/business/foodslabo/logo_12.png',
            styleClass: styles.content12,
        },
        {
            img: '/pages/business/foodslabo/logo_13.png',
            styleClass: styles.content13,
        },
    ]

    return (
        <div>
            <div className={styles.wrap}>
                {Array.from({ length: 3 }).map((_, slideIndex) => (
                    <ul
                        key={`slide-${slideIndex}`}
                        className={styles.slideShow}
                    >
                        {logos.map((logo, index) => (
                            <SlideImg
                                key={`slide-${slideIndex}-${index}`}
                                img={logo.img}
                                styleClass={logo.styleClass}
                            />
                        ))}
                    </ul>
                ))}
            </div>
        </div>
    )
}
